/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'
import classNames from 'classnames'

interface ItemBoxIcoProp {
  isGray?: boolean
}

const Color = css`
  width: inherit;
  height: auto;
  path {
    &.box-body {
      fill: #a67e4f;
    }
    &.box-light {
      fill: #d9ac80;
    }
    &.box-dark {
      fill: #926e43;
    }
  }
  &.is-gray {
    path {
      &.box-body {
        fill: #B7B7B7;
      }
      &.box-light {
        fill: #C9C9C9;
      }
      &.box-dark {
        fill: #929292;
      }
    }
  }
`
export default class ItemBoxIco extends PureComponent<ItemBoxIcoProp> {
  render() {
    const { isGray } = this.props
    const className = classNames(
      'item-box-icon',
      { 'is-gray': isGray },
    )

    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" css={Color}
           className={className}>
        <g id="그룹_36476" data-name="그룹 36476" transform="translate(-285 -442)">
          <g id="그룹_36178" data-name="그룹 36178" transform="translate(285 447.948)">
            <path id="패스_5359" data-name="패스 5359" d="M89.681,184.23l-11.724,4.1,11.724,4.69,11.724-4.69Zm0,0"
                  transform="translate(-72.775 -184.23)" className="box-dark"/>
            <path id="패스_5355" data-name="패스 5355"
                  d="M85.961,253.54,97.1,258.23l11.138-5.69V240.23L97.1,244.92l-11.138-4.69Zm0,0"
                  transform="translate(-80.098 -236.127)" className="box-body"/>
            <path id="패스_5356" data-name="패스 5356" d="M249.1,253.54V240.23l-11.138,4.69v13.31Zm0,0"
                  transform="translate(-220.961 -236.127)" className="box-dark"/>
            <path id="패스_5357" data-name="패스 5357" d="M5.957,244.92,17.095,250.2l5.862-5.276-11.724-4.69Zm0,0"
                  transform="translate(-5.957 -236.127)" className="box-light"/>
            <path id="패스_5358" data-name="패스 5358" d="M243.819,250.2l11.138-5.276-5.276-4.69-11.724,4.69Zm0,0"
                  transform="translate(-220.957 -236.127)"  className="box-light"/>
          </g>
        </g>
      </svg>
    )
  }
}
